import React from "react";
import "./style.scss";

function BannerSection({
  title = "",
  subtitle = "",
  bannerImage = "",
  image = "",
  parentClass = "",
}) {
  return (
    <div className={`banner-${title} ${parentClass}`} id="banner">
      {bannerImage && (
        <img
          className="service-banner-full"
          src={bannerImage}
          alt="this is background image"
          width="100%"
        />
      )}
      <div className="overlay">
        <div className="body-container">
          <div className="main-wrap-container">
            <div className="banner-left-side">
              <h1 className="banner-title">{title}</h1>
              <p className="banner-subtitle">{subtitle}</p>
            </div>
            {/* <div>
              <img
                className="image-right-side"
                src={image}
                alt="this is background image"
                width="100%"
              />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BannerSection;
